export enum NavigatorType {
  CleaningNavigator = "CleaningNavigator",
  NavigatorWrapperOnly = "NavigatorWrapperOnly",
}

export enum LocalizationMode {
  Localization = "Localization",
  Slam = "Slam",
}

export enum NavigatorAvailability {
  Public = "Public",
  AdvancedModeOnly = "AdvancedModeOnly",
}

export enum NavigatorName {
  DemoMode = "DemoMode",
  OpenSpaceWallFollow = "OpenSpaceWallFollow",
  RandomWallFollow = "RandomWallFollow",
  SpotCleaning = "SpotCleaning",
  SubZones = "SubZones",
  WallFollow = "WallFollow",
  ZoneCleaning = "ZoneCleaning",
  Maintenance = "Maintenance",
  RepeatPath = "RepeatPath",
  RepeatPathDemo = "RepeatPathDemo",
}

export const AutoFillInNavigator = "SubZones";